import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { Formik, Form, FieldArray } from 'formik'
import React from 'react'
import { Courier } from '../../../interfaces/Courier'
import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { DeleteIconButton } from '../../../components/Buttons/DeleteIcon'
import { AddIconButton } from '../../../components/Buttons/AddIcon'
import { CustomErrorMessage } from '../../../components/_WMS/CustomErrorComponent/CustomErrorComponent'
import { courierFormvalidationSchema, initialFormValues } from './config'
import { PriorizationDDL } from '../priorizationddl/PriorizationDDL'

interface CourierFormProps {
  onCreate: (success?: boolean) => void
  handleSnackbar: (msg: string | undefined, status: boolean) => void
}

const postCourier = (dto: Courier) => {
  const url = new URL(`${ApiConfig.CourierApi}`)
  return axios.post(url.toString(), dto)
}

export const CourierForm: React.FC<CourierFormProps> = ({
  onCreate,
  handleSnackbar
}) => {
  const { state, callApi } = useApi()

  const requestCreateCourier = (courier: Courier) => {
    callApi(postCourier(courier))
      .then(() => {
        handleSnackbar('Courier creado correctamente', true)
        onCreate(true)
      })
      .catch((error) => {
        handleSnackbar(error, false)
        onCreate()
      })
  }

  const isCreateButtonDisabled = (values: Courier) =>
    values.name.length === 0 || values.courierServices.length === 0

  if (state.status === Status.Loading) {
    return <Loading />
  }

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={courierFormvalidationSchema}
      onSubmit={requestCreateCourier}
    >
      {({ values, handleChange }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={5} sm={5}>
              <TextField
                fullWidth
                name='name'
                value={values.name}
                onChange={handleChange}
                label='Nombre de Courier'
                variant='outlined'
              />
            </Grid>
            <Grid item xs={5} sm={5}>
              <FormControlLabel
                control={
                  <Checkbox
                    name='hasPriorization'
                    size='medium'
                    color='primary'
                    onChange={handleChange}
                  />
                }
                label='Priorización'
              />
            </Grid>

            <Grid item xs={2} sm={2}>
              <Button
                fullWidth
                variant={'contained'}
                color='primary'
                type='submit'
                style={{ height: '100%' }}
                disabled={isCreateButtonDisabled(values)}
              >
                Crear
              </Button>
            </Grid>
          </Grid>

          <FieldArray name='courierServices'>
            {({ push, remove }) => (
              <Grid container spacing={2} direction={'row'}>
                <Grid
                  container
                  direction='column'
                  item
                  xs={12}
                  justifyContent='flex-end'
                  alignContent='flex-end'
                  alignItems='flex-end'
                >
                  <AddIconButton
                    companionText='Agregar Servicio'
                    fontSize={'small'}
                    onClick={() =>
                      push({
                        courierServiceId: 0,
                        name: '',
                        description: '',
                        createdAt: '',
                        courierId: 0,
                        typePriorityId: null
                      })
                    }
                  />
                  {values.courierServices.length === 0 && (
                    <Typography variant='caption' display='block' color='error'>
                      Debe agregar a lo menos un servicio
                    </Typography>
                  )}
                </Grid>
                {values.courierServices.map((service, index) => (
                  <Grid container item xs={12} spacing={2} direction='row'>
                    <Grid item xs={5}>
                      <TextField
                        variant='outlined'
                        fullWidth
                        name={`courierServices[${index}].name`}
                        value={service.name}
                        onChange={handleChange}
                        label='Nombre de servicio'
                      />
                      <CustomErrorMessage
                        name={`courierServices[${index}].name`}
                        component='div'
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Grid item xs={5} sm={5}>
                        <PriorizationDDL
                          onChange={handleChange}
                          value={service.typePriorityId || 0}
                          name={`courierServices[${index}].typePriorityId`}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                      <DeleteIconButton
                        fontSize='small'
                        onClick={() => remove(index)}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </FieldArray>
        </Form>
      )}
    </Formik>
  )
}
